export default __webpack_public_path__ + "static/media/pen-black.ebd4cc88.svg";